import script from "./PayTest.vue?vue&type=script&setup=true&lang=js"
export * from "./PayTest.vue?vue&type=script&setup=true&lang=js"

import "./PayTest.vue?vue&type=style&index=0&id=0db43b40&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0db43b40"]])

export default __exports__